import React from 'react';
import { Box, Paper, Typography, Stack, Grid } from '@mui/material';
import InputForm from "../../InputT";
import SearInputG from "../../SearchInput";
import CheckBox from "../../CheckBox";
import SearchModal from '../../SearchModal';
import ParamsPicklist from '../../../Types/ParamsPicklist';
import { Select, Form, Input } from 'antd';
import AntTable from '../../TableResizable';
import { SearchOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';

const { Option } = Select;

const searchCat: ParamsPicklist = { CodeAgence: '', Table: "CategorieActif", Colonne1: "CodeCategorie", Colonne2: "Libelle", Colagence: '101', Choix: 22 };
const searchFam: ParamsPicklist = { CodeAgence: '', Table: "FamilleActif", Colonne1: "CodeFamille", Colonne2: "Libelle", Colagence: '101', Choix: 22 };

interface ParentColumn {
    key: string;
    label: string;
    width?: number;
    align?: 'left' | 'center' | 'right';
    render: (row: any) => React.ReactNode;
}

interface Tab1Props {
    form?: any;
    glActifsValides: any[];
    disabledForm: boolean;
    listFinancements?: any[];
    columns: ParentColumn[];
    EtatG?: boolean;
    isRequired?: true;
}

const Tab1 = (props: Tab1Props) => {
    const [search, setSearch] = React.useState('');
    const antdColumns: ColumnsType<any> = props.columns.map((col: ParentColumn) => ({
        title: col.label, dataIndex: col.key, key: col.key, width: col.width, align: col.align || 'left',
        render: (_v: any, record: any) => col.render(record)
    }));
    const filteredActifs = props.glActifsValides.filter((row: any) =>
        Object.values(row).some(value => String(value ?? '').toLowerCase().includes(search.toLowerCase()))
    );

    return (
        <div className='tabItemAuto'>
            <Box className='border' sx={{ width: "85%", position: "absolute" }}>
                <legend> MISE EN PLACE DES CATÉGORIES D'ACTIFS </legend>

                <Box sx={{ p: 2, mt: -2 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={6} sx={{ pr: 2 }}>
                            <SearchModal width={5} notRequired form={props.form} Titre={'Recherche Catégorie'} label={'Code Catégorie'} name={'CODECATEGORIE'} Parametre={searchCat} disabled={props.EtatG} />
                            <InputForm width={5} label="Libellé" type="texte" name="LIBELLE" disabled={props.disabledForm} />
                            <SearInputG width={5} form={props.form} Titre={'Recherche Famille'} label={'Famille'} name={'FAMILLE'} Parametre={searchFam} dissabledCode={props.disabledForm} />
                        </Grid>

                        <Grid item xs={12} md={6} lg={6} className='border-left' sx={{ pl: 2 }}>
                            <InputForm width={6} label="Règles d'usage" type="TextArea" name="REGLESUSAGE" disabled={props.disabledForm} row={1} />

                            <Form.Item label="Financements" name="FINANCEMENT_ELIGIBLES" labelCol={{ span: 6 }} rules={[{ required: !props.isRequired, message: "" }]} labelAlign="left">
                                <Select mode="multiple" placeholder="Types autorisés" style={{ width: '100%' }} disabled={props.disabledForm}>
                                    {props.listFinancements?.map((f: any) => <Option key={f.CODE} value={f.CODE}>{f.LIBELLE}</Option>)}
                                </Select>
                            </Form.Item>

                            <Box sx={{ ml: `${(7 / 24) * 100}%`, mt: 2, display: 'flex', alignItems: 'center', gap: 2, '& .ant-form-item': { marginBottom: 0 } }}>
                                <CheckBox notRequired form={props.form} label="Actif" name="ESTACTIF" disabled={props.disabledForm} />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>

                {/* --- INVENTAIRE DES ACTIFS VALIDÉS : STRICTEMENT LECTURE SEULE --- */}
                <Box sx={{ p: 2 }}>
                    <Paper elevation={2} sx={{ p: 2, borderRadius: 3 }}>
                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems={{ xs: 'stretch', sm: 'center' }} sx={{ mb: 2 }}>
                            <Box>
                                <Typography variant="h6" fontWeight="bold" color="#04446e">Actifs validés de la catégorie</Typography>
                                <Typography variant="body2" color="textSecondary">
                                    {filteredActifs.length} actif(s) validé(s) et disponible(s)
                                </Typography>
                            </Box>
                            <Input size="small" allowClear prefix={<SearchOutlined />} placeholder="Rechercher..." value={search} onChange={event => setSearch(event.target.value)} style={{ width: 220 }} />
                        </Stack>

                        <Box sx={{ maxHeight: 'calc(100vh - 380px)', 
                            minHeight: '250px', 
                            //overflowX: 'auto',
                            width: '100%',
                            '& .ant-table-content, & .ant-table-body': {
                            '&::-webkit-scrollbar': { height: '5px', width: '5px' }, // Observation : Scrollbar fine
                            '&::-webkit-scrollbar-track': { backgroundColor: '#f1f1f1' },
                            '&::-webkit-scrollbar-thumb': { backgroundColor: '#ccc', borderRadius: '10px' },
                            '&::-webkit-scrollbar-thumb:hover': { backgroundColor: '#2A6596' },
                        }}}>
                            <AntTable
                                dataSource={filteredActifs}
                                columns={antdColumns}
                                rowKey={(record: any, index?: number) => `${record.CODEACTIF || '-'}-${index}`}
                                size="small"
                                pagination={false}
                                sticky={true}
                                scroll={{ x: 'max-content' }}
                            />
                        </Box>
                    </Paper>
                </Box>
            </Box>
        </div>
    );
};

export default Tab1;